/** One Soft Release / Super Soft Release: its lots, the note, per-lot Cancel and Acknowledge. */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { SOFT_RELEASE_KINDS } from "@nexseed/shared";
import { useAuth } from "@/features/auth/store";
import { SoftReleaseDetailPage } from "@/features/quality/components/soft-release/soft-release-detail-page";

export const Route = createFileRoute("/_app/quality/releases/$kind/$releaseId")(
  {
    params: {
      parse: ({ kind, releaseId }) => {
        if (
          !(SOFT_RELEASE_KINDS as readonly string[]).includes(kind) ||
          !/^\d+$/.test(releaseId)
        )
          throw notFound();
        return {
          kind: kind as (typeof SOFT_RELEASE_KINDS)[number],
          releaseId,
        };
      },
      stringify: (p) => p,
    },
    beforeLoad: () => {
      const can = useAuth.getState().can;
      if (
        !can("qc.view") &&
        !can("qc.soft_release") &&
        !can("qc.super_soft_release")
      )
        throw redirect({ to: "/" });
    },
    component: Page,
  }
);

function Page() {
  const { kind, releaseId } = Route.useParams();
  return <SoftReleaseDetailPage kind={kind} id={Number(releaseId)} />;
}
